import { Link, graphql, useStaticQuery } from "gatsby"
import React from "react"

export default function Footer({ locale }) {
  const { footer, footer_en } = useStaticQuery(graphql`
    query footerQuery {
      footer: wpMenu(id: { eq: "dGVybTozOQ==" }) {
        id
        menuItems {
          nodes {
            childItems {
              nodes {
                label
                path
              }
            }
            label
          }
        }
      }
      footer_en: wpMenu(id: { eq: "dGVybToxMzc=" }) {
        id
        menuItems {
          nodes {
            childItems {
              nodes {
                label
                path
              }
            }
            label
          }
        }
      }
    }
  `)
  const menuItems =
    locale === "en_GB" ? footer_en?.menuItems?.nodes : footer?.menuItems?.nodes

  const footer_legal = menuItems?.find(i => i.label === "legal_footer")

  const menu = menuItems
    ?.filter(elem => elem?.childItems?.nodes.length > 0)
    ?.filter(i => i.label !== "legal_footer")
  if (!menu) return null

  return (
    <footer
      className="text-white bg-[#121314] relative"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="px-4 mx-auto  sm:px-6 lg:px-8 lg:max-w-7xl py-12  lg:py-16 ">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="xl:col-span-1">
            <img className="h-16 mb-6" src="/logo-footer.png" alt="Swizi" />
            <h3 className="pr-6 mb-2 text-sm font-bold">
              Make the work a SMARTer place
            </h3>
            <p className="text-sm mt-4 hidden xl:block">
              Swizi est membre actif de:
            </p>
            <a
              className="hidden xl:inline-block"
              href="https://www.idet.fr/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                width="100"
                height="40"
                viewBox="0 0 178 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 51.9097H25.8053L0 25.9548V51.9097Z" fill="white" />
                <path d="M51.6105 0H25.8052L51.6105 25.9549V0Z" fill="white" />
                <path
                  d="M25.8052 25.9548H51.6105L25.8052 51.9097V25.9548Z"
                  fill="white"
                />
                <path d="M0 0H25.8053L0 25.9549V0Z" fill="white" />
                <path
                  d="M64.8142 9.26025H74.3186V42.8537H64.8142V9.26025Z"
                  fill="white"
                />
                <path
                  d="M79.5758 9.26025H89.1723C96.0916 9.26025 101.306 10.4214 104.857 13.1116C108.547 15.8944 110.577 20.4438 110.577 26.1045C110.577 31.1145 109.01 35.2911 105.825 38.214C102.503 41.2296 97.3829 42.8537 89.354 42.8537H79.5735V9.26025H79.5758ZM89.4485 34.7806C95.492 34.7806 97.9377 33.5744 99.3683 31.8577C100.615 30.3262 101.075 28.2842 101.075 26.1045C101.075 22.9488 100.107 20.6741 98.2139 19.2376C96.1837 17.7061 93.1407 17.3357 89.4036 17.3357H89.0802V34.783H89.4485V34.7806Z"
                  fill="white"
                />
                <path
                  d="M114.541 9.26025H136.317V17.3333H124.045V21.6025H134.426V29.2126H124.045V34.7806H136.869V42.8537H114.541V9.26025Z"
                  fill="white"
                />
                <path
                  d="M149.553 17.3333H138.944V9.26025H169.669V17.3333H159.057V42.8537H149.553V17.3333V17.3333Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
          <div className="grid grid-cols-3 gap-2 md:gap-8 mt-12 xl:mt-0 xl:col-span-2">
            {menu.map(column => (
              <div key={column.label}>
                <h3 className="text-lg font-semibold tracking-wider uppercase">
                  {column.label}
                </h3>
                <ul className="mt-4 space-y-2">
                  {column.childItems.nodes.map(item => (
                    <li key={item.label}>
                      <Link
                        to={item.path}
                        className="text-sm hover:text-gray-200"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="xl:hidden mt-8">
            <p className="text-sm mt-4">Swizi est memebre actif de:</p>
            <a href="https://www.idet.fr/" target="_blank" rel="noreferrer">
              <svg
                width="100"
                height="40"
                viewBox="0 0 178 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 51.9097H25.8053L0 25.9548V51.9097Z" fill="white" />
                <path d="M51.6105 0H25.8052L51.6105 25.9549V0Z" fill="white" />
                <path
                  d="M25.8052 25.9548H51.6105L25.8052 51.9097V25.9548Z"
                  fill="white"
                />
                <path d="M0 0H25.8053L0 25.9549V0Z" fill="white" />
                <path
                  d="M64.8142 9.26025H74.3186V42.8537H64.8142V9.26025Z"
                  fill="white"
                />
                <path
                  d="M79.5758 9.26025H89.1723C96.0916 9.26025 101.306 10.4214 104.857 13.1116C108.547 15.8944 110.577 20.4438 110.577 26.1045C110.577 31.1145 109.01 35.2911 105.825 38.214C102.503 41.2296 97.3829 42.8537 89.354 42.8537H79.5735V9.26025H79.5758ZM89.4485 34.7806C95.492 34.7806 97.9377 33.5744 99.3683 31.8577C100.615 30.3262 101.075 28.2842 101.075 26.1045C101.075 22.9488 100.107 20.6741 98.2139 19.2376C96.1837 17.7061 93.1407 17.3357 89.4036 17.3357H89.0802V34.783H89.4485V34.7806Z"
                  fill="white"
                />
                <path
                  d="M114.541 9.26025H136.317V17.3333H124.045V21.6025H134.426V29.2126H124.045V34.7806H136.869V42.8537H114.541V9.26025Z"
                  fill="white"
                />
                <path
                  d="M149.553 17.3333H138.944V9.26025H169.669V17.3333H159.057V42.8537H149.553V17.3333V17.3333Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
        {footer_legal?.childItems?.nodes.length > 0 && (
          <div className="pt-4 mt-8 border-t border-gray-200">
            <ul className="flex justify-center space-x-6 text-sm">
              {footer_legal?.childItems?.nodes.map(item => {
                return (
                  <li key={item.path}>
                    <Link to={item.path}>{item.label}</Link>
                  </li>
                )
              })}
            </ul>
          </div>
        )}
      </div>
    </footer>
  )
}
